import './index.scss';

const ResultSection = () => {
  return (
    <section className='Result_section'>
      <div className='container'>
        <header>
          <h2>Що ти отримаєш?</h2>
          <hr />
          <p>✅ Навчишся обирати, доглядати та озеленювати простір без хаосу та випадкових рішень.</p>
          <p>✅ Отримаєш структуровану базу: від вибору ґрунту і кашпо — до освітлення, поливу та профілактики проблем.</p>
          <p>✅ Зможеш самостійно озеленювати квартиру, офіс, кав’ярню або інший простір — стабільно заробляючи гроші</p>
          <br />
          <p style={{fontWeight: 'bold'}}>📖 Додаткові матеріали:</p>
          <ul>
            <li>Гайд: Як обрати здорову рослину</li>
            <li>Гайд: Аптечка для рослин</li>
            <li>Гайд: Кого та коли поливати</li>
            <li>Посібник: Освітлення для різних кімнатних рослин</li>
            <li>Посібник: Особливості варієгатних рослин</li>
          </ul>
        </header>
      </div>
    </section>
  );
};

export default ResultSection;
